import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WardrobeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WardrobeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.4552 11.5588C10.4552 11.8791 10.1956 12.1387 9.87533 12.1387C9.55516 12.1387 9.29541 11.8791 9.29541 11.5588C9.29541 11.2385 9.55517 10.9789 9.87533 10.9789C10.1957 10.9789 10.4552 11.2385 10.4552 11.5588Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4245 11.5588C15.4245 11.8791 15.1649 12.1387 14.8446 12.1387C14.5243 12.1387 14.2646 11.8791 14.2646 11.5588C14.2646 11.2385 14.5243 10.9789 14.8446 10.9789C15.1649 10.9789 15.4245 11.2385 15.4245 11.5588Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4347 2.28259H4.28451C3.96419 2.28259 3.70459 2.5422 3.70459 2.86251V20.2551C3.70459 20.5754 3.9642 20.835 4.28451 20.835H4.94689V21.4974C4.94689 21.8177 5.2065 22.0773 5.52681 22.0773C5.84712 22.0773 6.10673 21.8177 6.10673 21.4974V20.835H18.6126V21.4974C18.6126 21.8177 18.8722 22.0773 19.1925 22.0773C19.5127 22.0773 19.7724 21.8177 19.7724 21.4974V20.835H20.4348C20.7549 20.835 21.0147 20.5754 21.0147 20.2551V2.86251C21.0145 2.54219 20.755 2.28259 20.4347 2.28259ZM4.86444 3.44244H11.7797V19.6752H4.86444V3.44244ZM19.8547 19.6752H12.9396V3.44244H19.8547V19.6752Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default WardrobeIcon;
